module.exports = __webpack_public_path__ + "img/Belka.ceba43cf.png";